export const ZingColors = {
  primaryColor: '#25578F',
  primaryColor10: '#0C2833',
  primaryColor35: '#25578F',
  primaryColor90: '#D9E8F2',
  backgroundColor: '#EBF4FA',
  darkColor: '#01252E',
  darkColor2: '#0B242D',
  darkColor3: '#0C2833',
  greyColor: '#9192A9',
  greyColor2: '#0B242D',
  greyColor3: '#E0E0E0',
  skyBlueColor: '#D9E8F2',
  veryLightGrey: '#F9F9F9',
  surface5: '#CED5DD',

  red: '#D44E3E',
  red200: '#FFD9D9',
  red200a: '#FFB3B3',
  red700: '#E50000',
  red800: '#C20000',
  red500: '#FF8080',
  red50: '#FFEBEB',

  kPrimaryColor: '#6F35A5',
  kPrimaryLightColor: '#F1E6FF',
  logoRed: '#ED1C24',

  loginGradientStart: '#0071BC',
  loginGradientEnd: '#73B2D3',

  primaryDarkColor: '#008DC9', // NEW BLUE
  accentColor: '#D86422', // ORANGE
  whoAccentYellowColor: '#FFCC00', // YELLOW
  accentTealColor: '#44BBA4', // TEAL
  accentNavyColor: '#1A458E', // NAVY
  yellow: '#FFB200',

  greyBackgroundColor: '#F9F8F7', // GREY
  whoBackgroundBlueColor: '#007EB4', // ZingData BLUE 2
  homeHeaderGreenColor: '#FAE8A9',
  nlqTextHighlightColor: '#A2B4C8',

  bodyTextColor: '#272626', // CHARCOAL
  textColor: '#3C4245', // GREY
  emergencyRedColor: '#D82037',
  menuButtonColor: '#CC1694BE',
  successCheckColor: '#9BC53D', // NEW GREEN
  itemBorderColor: 'rgba(92, 97, 100, 0.25)',

  neutral1Color: '#050C1D',
  neutral2Color: '#26354E',
  neutral3Color: '#C9CDD6', // LIGHT GREY
  neutralTextColor: '#3C4245',
  neutralTextLightColor: '#5C6164',
  neutralTextDarkColor: '#1C1E1F',
  neutral900: '#092D53',
  neutral500: '#9DABBA',
  neutral600: '#8496A9',
  neutral700: '#5F768F',
  neutral65: '#A6A6A6',
  neutral50: '#F2F4F6',
  neutralA50: 'rgba(9, 45, 83, 0.05)',
  neutralA100: 'rgba(9, 45, 83, 0.10)',
  neutral100: '#E7EAEE',
  neutral73: '#BBBBBB',
  surface1: '#F9FAFB',

  illustrationBlue1Color: '#D5F5FD',
  illustrationPinkColor: '#EC96AA', // PINK

  neutral200: '#DAE0E5',
  neutral300: '#092D53',

  blue700: '#1D73C9',
  blue800: '#1D61A5',
  blue50a: '#9ECCFA',
  blue50: '#E6F2FD',
  blue200: '#CFE6FD',
  blue600: '#308CE8',
  orange500: '#FFA142',
  orange600: '#FF6A00',
  orange700: '#C75300',

  green600: '#469D34',
  green500: '#55BF40',
  purple500: '#C297ED',
  purple600: '#A670DB',
  teal500: '#14B8B8',
  teal600: '#169A9A',
  magenta500: '#EA86C8',
  magenta600: '#D65CAD',
  yellow600: '#FFD500',
  yellow700: '#DBAF00',
  blue500: '#68ADF3',
  red600: '#FF4242',
  tertiary: '#FF8000',
  grey900: '#1E2022',
  grey400: '#BDC5D1',

  mapColors: [
    '#308CE8',
    '#FF8080',
    '#469D34',
    '#C297ED',
    '#FFA142',
    '#14B8B8',
    '#D65CAD',
    '#FFD500',
    '#68ADF3',
    '#FF4242',
    '#55BF40',
    '#A670DB',
    '#FF8000',
    '#169A9A',
    '#EA86C8',
    '#DBAF00',
  ],

  mapGradient: {
    colors: ['#FFD500', '#FFA142', '#FF4242', '#BF4095', '#5E3885'],
    stops: [0.0, 0.2, 0.4, 0.6, 0.8],
  },
};
